module.exports = __webpack_public_path__ + "static/media/searching-rides.9a766aae.png";